import locale from "localization";

export const nonFuelColumns = [
  {
    key: "paymentId",
    text: locale.locqPayId,
    style: {
      minWidth: "70px",
    },
  },
  {
    key: "createdAt",
    text: locale.dateOfTransaction,
    style: {
      minWidth: "70px",
    },
  },
  {
    key: "nameAndMobileNumber",
    text: (
      <>
        {locale.name} / <br /> {locale.mobileNumber}
      </>
    ),
    style: { minWidth: "10%" },
  },
  {
    key: "amount",
    text: locale.paymentAmount,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "status",
    text: `${locale.status}`,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "settlementStatus",
    text: `${locale.settlementStatus}`,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "settlementId",
    text: `${locale.settlementId}`,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "merchant",
    text: `${locale.merchantName} / ${locale.customerName}`,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "settlementPayee",
    text: `${locale.settlementPayee}`,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "action",
    text: `${locale.action}`,
    style: {
      minWidth: "120px",
    },
  },
];
